import { render, staticRenderFns } from "./modalJenisTransaksi.vue?vue&type=template&id=2776e59b&"
import script from "./modalJenisTransaksi.vue?vue&type=script&lang=js&"
export * from "./modalJenisTransaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports